(() => {
  'use strict';
  const node = document.getElementById('nwb-catalog-link-config');
  if (!node) return;
  const config = JSON.parse(node.textContent);
  const normalize = value => value.replace(/\/+$/, '') || '/';
  const unavailable = new Set(config.unavailable || []);
  const aliases = config.aliases || {};
  const nativeSourcePaths = new Set(config.native_source_paths || []);
  function resolve(value) {
    if (!value) return value;
    let url;
    try { url = new URL(value, location.origin); } catch (_) { return value; }
    const sourceOrigin = url.origin === 'https://us.narwal.com' || url.origin === 'http://us.narwal.com';
    if (url.origin !== location.origin && !sourceOrigin) return value;
    let originalPath;
    try { originalPath = normalize(decodeURIComponent(url.pathname)); } catch (_) { return value; }
    const demoPrefix = '/demo/narwal-us-complete';
    const fromDemo = originalPath === demoPrefix || originalPath.startsWith(demoPrefix + '/');
    const sourcePath = fromDemo ? normalize(originalPath.slice(demoPrefix.length)) : originalPath;
    const destinationPath = aliases[sourcePath] || sourcePath;
    const match = destinationPath.match(/^\/products\/([^/]+)$/);
    const handle = match && match[1];
    const knownSource = Boolean(aliases[sourcePath]) || nativeSourcePaths.has(sourcePath) || (handle && unavailable.has(handle));
    if ((sourceOrigin || fromDemo) && !knownSource) return value;
    if (handle && (config.empty || unavailable.has(handle))) {
      const info = config.information[handle];
      if (info && info !== config.contact && normalize(info) !== normalize(location.pathname)) return info;
      return `${config.contact}?model=${encodeURIComponent(handle)}`;
    }
    if (sourceOrigin || fromDemo || destinationPath !== originalPath) return encodeURI(destinationPath) + url.search + url.hash;
    return value;
  }
  window.NwbCatalogLinks = { resolve };
  function update(root) {
    const nodes = Array.from(root.querySelectorAll('a[href], [data-nwb-product-destination]'));
    if (root.matches?.('a[href], [data-nwb-product-destination]')) nodes.unshift(root);
    nodes.forEach(link => {
      const original = link.dataset.nwbProductDestination || link.getAttribute('href');
      const destination = resolve(original);
      if (!original) return;
      if (destination !== original) {
        if (link.hasAttribute('href') && link.getAttribute('href') !== destination) link.setAttribute('href', destination);
        if (link.dataset.nwbProductDestination && link.dataset.nwbProductDestination !== destination) link.dataset.nwbProductDestination = destination;
        link.dataset.nwbOriginalProductUrl = original;
      } else if (link.dataset.nwbProductDestination && link.hasAttribute('href') && link.getAttribute('href') !== destination) {
        link.setAttribute('href', destination);
      }
      const isInformation = Object.values(config.information).includes(destination);
      const isContact = destination.startsWith(config.contact + '?model=');
      if (!isInformation && !isContact) return;
      if (/^(Купить(?: сейчас)?|Buy(?: Now)?)$/i.test(link.textContent.trim())) {
        link.textContent = destination.startsWith(config.contact) ? 'Уточнить наличие' : 'Узнать больше';
      }
    });
  }
  function prefillModelContact() {
    if (normalize(location.pathname) !== normalize(config.contact)) return;
    const model = new URLSearchParams(location.search).get('model');
    if (!model || model.length > 160) return;
    const message = document.querySelector('textarea[name="contact[body]"], textarea[name="contact[message]"]');
    if (!message || message.value.trim()) return;
    message.value = `Здравствуйте! Подскажите, пожалуйста, наличие и подробности о модели ${model.replace(/-/g, ' ')}.`;
    message.dispatchEvent(new Event('input', { bubbles: true }));
    const shell = message.closest('[data-nwb-support-shell]');
    const dialogState = shell && window.NarwalFooterSupport?.states?.get(shell);
    if (dialogState) dialogState.open();
    else message.scrollIntoView({ block: 'center' });
  }
  if (document.readyState === 'complete') prefillModelContact();
  else document.addEventListener('DOMContentLoaded', prefillModelContact, { once: true });
  update(document);
  const observer = new MutationObserver(records => records.forEach(record => {
    if (record.type === 'attributes') update(record.target);
    record.addedNodes.forEach(added => {
      if (added.nodeType === Node.ELEMENT_NODE) update(added);
    });
  }));
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'data-nwb-product-destination'] });
  document.addEventListener('shopify:section:load', event => update(event.target));
})();
